// initial state
import * as base from './base.js'
const baseName = '/admin/hospitalbackstage'

const baseNameList = baseName+'/list'

const obj = base.setBaseUrl('hospitalbackstage', baseName)
const obj1 = base.setBaseUrl('list', baseNameList)




const a = Object.assign(obj,obj1,{baseNameList} )
export default a